import React from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import { LazyQueryNetworkBoundrary } from "../../../../../components/mobile/QueryNetworkBoundrary";
import { UserLoggedInNavigatorScreenProps } from "../../../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";

import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";

import { WSNoteQuery } from "./__generated__/WSNoteQuery.graphql";

import { NoteSettings } from "./NoteSettings";
import { SafeAreaProvider } from "react-native-safe-area-context";

const WS_NOTE_QUERY = graphql`
  query WSNoteQuery($id: ID!) {
    widgetNote(id: $id) {
      note {
        ...NoteSettings_Note
      }
    }
  }
`;

export const WSNote = withWebModal(WSNoteOverviewC, true);
function WSNoteOverviewC(props: UserLoggedInNavigatorScreenProps<"WSNote">) {
  return (
    <SafeAreaProvider>
      <LazyQueryNetworkBoundrary>
        {(fetchKey) => <InnerWSNoteOverview {...props} fetchKey={fetchKey} />}
      </LazyQueryNetworkBoundrary>
    </SafeAreaProvider>
  );
}

function InnerWSNoteOverview(
  props: UserLoggedInNavigatorScreenProps<"WSNote"> & {
    fetchKey: string;
  }
) {
  const data = useLazyLoadQuery<WSNoteQuery>(
    WS_NOTE_QUERY,
    {
      id: props.route.params.widgetId,
    },
    { fetchKey: props.fetchKey, fetchPolicy: "store-and-network" }
  );

  if (!data.widgetNote) {
    return null;
  }
  return (
    <NoteSettings close={props.navigation.goBack} note={data.widgetNote.note} />
  );
}
